var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeBased(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    zoomAndPan: "magnify",
    viewBox: "0 0 150 149.999998",
    height: 200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "977e82dffd"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "07b15ed482"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 150,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAAAAAAZai4+AAAAAmJLR0QA/4ePzL8AAAJZSURBVHic7VvRcsMwCHN3+/9fzl52XdrUWMJyh3vSa0HIgN3kglszDMMwDMMwDMMwDCOH2zTDsYJ1juCVJAnzhHOkaZY87TkWNUOf9MNE5QNkvHBN6RgJF1ZVJgjtwYvKhGHtc6roOJz5S1FXCtAsAGV8Ddd3Z2yvYGwvkWJn0jxr+hxm7Mp78JZPMTDHlBNj+BgguxrUD7V7YJ/YvqAraDahKuWcaBH+r4R3h4zOtD2HA/gVD4nY4Kpkur7GJmeknxpJR0DWaaH8CfrKFfi7H8uCVAGRKF1kEd+FoSyqhCGYdI1k6VRRuvAizr9/ExQDWdln5CEGxHC2BMkiSGJZy5I1okazJUkWTrPjufWXaFGyzkRhFXfM1h2yZKFUkayF+3BED2VLmCwQ7+8taI37tfzi1goDINkStxZCt18R/xOWxeBbTaj5MvWWbPFHTV+W8tjqcPVDFO2tz5alfsboy1JG6nD1Q6iKGC6CX6Hs3Lp191Um7cLjVFn1z96JamwsS/z0jNAFspa/hgUBNi6iFlBLQLKWv5pdEMla3FwRPVZEYbowqqItj84MqAoKMhbNFipL1F0oTSxr4V6MqeEiStIFkwxkLUvXgBhveUG6hBOFwg+KBBX1UVw2OzskKnpuAQkQpYuiIadG8ro4ErKI6e1IOspGf7QMOw9KVR0rqzqEV3VkMcufXE1+HJadk6OC7T88XHXUuupgei/inSn+lcCHXHpoRa+ItKoXahonLBUh+1yHCkvyTzwGl7za1lqreRHwFwWvTZ5xSNkMwzAMwzAMwzAMoz5+AAXscqIu+B0fAAAAAElFTkSuQmCC",
    id: "bcb52434a8",
    height: 150,
    preserveAspectRatio: "xMidYMid meet"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "4ac3178151"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#977e82dffd)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#07b15ed482)",
    transform: "matrix(0.8, 0, 0, 0.8, 15, 14.999994)"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 150,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAAAAAAZai4+AAAAAmJLR0QA/4ePzL8AAAJZSURBVHic7VvRcsMwCHN3+/9fzl52XdrUWMJyh3vSa0HIgN3kglszDMMwDMMwDMMwDCOH2zTDsYJ1juCVJAnzhHOkaZY87TkWNUOf9MNE5QNkvHBN6RgJF1ZVJgjtwYvKhGHtc6roOJz5S1FXCtAsAGV8Ddd3Z2yvYGwvkWJn0jxr+hxm7Mp78JZPMTDHlBNj+BgguxrUD7V7YJ/YvqAraDahKuWcaBH+r4R3h4zOtD2HA/gVD4nY4Kpkur7GJmeknxpJR0DWaaH8CfrKFfi7H8uCVAGRKF1kEd+FoSyqhCGYdI1k6VRRuvAizr9/ExQDWdln5CEGxHC2BMkiSGJZy5I1okazJUkWTrPjufWXaFGyzkRhFXfM1h2yZKFUkayF+3BED2VLmCwQ7+8taI37tfzi1goDINkStxZCt18R/xOWxeBbTaj5MvWWbPFHTV+W8tjqcPVDFO2tz5alfsboy1JG6nD1Q6iKGC6CX6Hs3Lp191Um7cLjVFn1z96JamwsS/z0jNAFspa/hgUBNi6iFlBLQLKWv5pdEMla3FwRPVZEYbowqqItj84MqAoKMhbNFipL1F0oTSxr4V6MqeEiStIFkwxkLUvXgBhveUG6hBOFwg+KBBX1UVw2OzskKnpuAQkQpYuiIadG8ro4ErKI6e1IOspGf7QMOw9KVR0rqzqEV3VkMcufXE1+HJadk6OC7T88XHXUuupgei/inSn+lcCHXHpoRa+ItKoXahonLBUh+1yHCkvyTzwGl7za1lqreRHwFwWvTZ5xSNkMwzAMwzAMwzAMoz5+AAXscqIu+B0fAAAAAElFTkSuQmCC",
    height: 150,
    preserveAspectRatio: "xMidYMid meet"
  })))), /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 150,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAIAAACzY+a1AAAABmJLR0QA/wD/AP+gvaeTAAABcElEQVR4nO3RwQkAIBDAMHX/nc8hfEghmaDQPTOLsvM7gFcW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkXvY0EKVRWAB8AAAAASUVORK5CYII=",
    id: "6ec8f1c7de",
    height: 150,
    preserveAspectRatio: "xMidYMid meet"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#4ac3178151)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8, 0, 0, 0.8, 15, 14.999994)"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 150,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAIAAACzY+a1AAAABmJLR0QA/wD/AP+gvaeTAAABcElEQVR4nO3RwQkAIBDAMHX/nc8hfEghmaDQPTOLsvM7gFcW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkW5lmYZ2GehXkXvY0EKVRWAB8AAAAASUVORK5CYII=",
    height: 150,
    preserveAspectRatio: "xMidYMid meet"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeBased);
export default __webpack_public_path__ + "static/media/time-based.6221b017867217764576648c2f86b968.svg";
export { ForwardRef as ReactComponent };